module.exports = "https://static.im-cdn.com/mjc/storefront/Runway/static/media/mZoom.47a32e19.svg";